import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocStereoTypeDto, DocStereoTypesDto } from '../models/DocStereoTypeDto';
import { GenericFilter } from '../models/GenericFilter';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class GenericDocumentService extends BaseService {  

   docStereoTypeDto:DocStereoTypeDto[] = [];

  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService) {
    super();
  }

  getDocStereoType(id: string, dbname: string): Observable<DocStereoTypeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<DocStereoTypeDto>(`${this.genericDocuments}/${id}`, { headers: headers });
  }

  loadDocStereoTypes(serachText: string, page: number, pageSize: number, dbname: string): Observable<DocStereoTypesDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
      console.log(headers)
    return this.httpClient.get<DocStereoTypesDto>(`${this.genericDocuments}?searchText=${serachText}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  loadDocStereoTypesx(dbname: string, genericFilter: GenericFilter) : Observable<DocStereoTypeDto[]> {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`)
    .set('dbname', dbname);
  return this.httpClient.post<DocStereoTypeDto[]>(`${this.genericDocuments}/GetFilteredDocStereoTypes`,genericFilter, { headers: headers });
  }

  getDocStereoTypes(serachText: string, page: number, pageSize: number, dbname: string)  {    
    return this.loadDocStereoTypes(serachText, page, pageSize, dbname).pipe(map((docstereotypes:DocStereoTypesDto) => docstereotypes.docStereoTypes || [] ));
  }

  createDocStereoType(docStereoTypeDto: DocStereoTypeDto, dbname: string): Observable<DocStereoTypeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<DocStereoTypeDto>(`${this.genericDocuments}`, docStereoTypeDto, { headers: headers });
  }

  updateDocStereoType(docStereoTypeDto: DocStereoTypeDto, dbname: string): Observable<DocStereoTypeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.put<DocStereoTypeDto>(`${this.genericDocuments}`, docStereoTypeDto, { headers: headers });
  }

  deleteDocStereoType(docStereoTypeDto: DocStereoTypeDto, dbname: string): Observable<DocStereoTypeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.delete<DocStereoTypeDto>(`${this.genericDocuments}/${docStereoTypeDto.id}`, { headers: headers });
  }
}
